import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {Form} from "react-bootstrap";
import {AdminJobService} from "../service";
import {IJob} from "../interface";
import CreateForm from "./CreateForm";

const UpdateJob = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [state, setState] = useState<IJob | null>(null);
    const [image, setImage] = useState<File | null>(null);
    const submitHandler = () => {
        const formData = new FormData();
        formData.append('body', JSON.stringify(state))
        image && formData.append("image", image);
        !!state?.id && AdminJobService.update(formData , state?.id)
            .then(() => {
                SuccessToast(t(`jobs.successfully_updated`));
                navigate(-1);
                setState(null);
            })
            .catch(ErrorToast);
    };

    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState} setImage={setImage}/>
            </Form>
        </div>
    );
};

export default UpdateJob;